<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible="visible"
    width="960px"
    :title="$l('dialog_choose_workshop_title') || '选择验货间'"
    :close-on-click-modal="false"
    :before-close="close"
    append-to-body
    v-el-dialog-drag
  >
    <PageMain
      ref="pageMain"
      :loading="loading"
      :tableData="tableData"
      :tablePage="page"
      @chooseChange="chooseChange"
    >
      <template #header>
        <PageHeader
          ref="header"
          @query="getData"
          @reset="resetPage"
        />
      </template>
      <template #pager>
        <pagination
          size="small"
          align="right"
          :current-page="page.curPage"
          :page-size="page.pageSize"
          :page-total="page.pageTotal"
          @change="handlePaginationChange"
        />
      </template>
    </PageMain>
    <span slot="footer">
      <el-button size="small" @click="close">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button
        type="primary"
        size="small"
        :disabled="!selectedRow"
        @click="confirm"
      >
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import BaseTable from '@/mixins/base-table'
import PageHeader from './header.vue'
import PageMain from './main.vue'

export default {
  components: { PageHeader, PageMain },
  mixins: [BaseTable],
  props: {
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      usePage: true,
      selectedRow: null,
    }
  },
  methods: {
    getData(form = {}) {
      this.loading = true
      this.$api
        .dfInspectionWorkshopListApi({
          keyword: '',
          workshopName: form.workshopName || '',
          workshopStatusList: ['Y'],
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    chooseChange(row) {
      this.selectedRow = row
    },
    confirm() {
      if (!this.selectedRow) return
      this.$emit('confirm', this.selectedRow)
      this.close()
    },
    close() {
      this.selectedRow = null
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
